import { render, staticRenderFns } from "./HSCodeListPage.vue?vue&type=template&id=89a802a2&"
import script from "./HSCodeListPage.vue?vue&type=script&lang=ts&"
export * from "./HSCodeListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports